import createModal from '../components/createModal';
import { $ } from '../util/DOM';

const svg = {
  prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.823 240.823" width="36" height="36"><path d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179   l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816   C52.942,116.507,52.942,124.327,57.633,129.007z"/></svg>',
  next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240.823 240.823" width="36" height="36"><path d="M183.189,111.816L74.892,3.555c-4.752-4.74-12.451-4.74-17.215,0c-4.752,4.74-4.752,12.439,0,17.179   l99.707,99.671l-99.695,99.671c-4.752,4.74-4.752,12.439,0,17.191c4.752,4.74,12.463,4.74,17.215,0l108.297-108.261   C187.881,124.315,187.881,116.495,183.189,111.816z"/></svg>',
};

const imageView = ({ href, title }, onclick) => {
  const modal = createModal(/* html */ `
<img class="modal-photo" src="${href}" alt="${title}" />
`, true);

  $.render(modal.container, {
    children: [
      $.render('button', {
        type: 'button',
        className: 'modal__prev-button',
        innerHTML: svg.prev,
        events: {
          click: () => onclick(-1),
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'modal__next-button',
        innerHTML: svg.next,
        events: {
          click: () => onclick(+1),
        },
      }),
    ],
  });

  return modal;
};

const initGallery = () => {
  $('.gallery__container').forEach((container) => {
    const photos = $('.gallery__item', container);
    photos.forEach((p, index) => {
      // eslint-disable-next-line no-param-reassign
      p.modal = imageView(p, (i) => {
        const selectedIndex = index + i;
        p.modal.close();
        if (selectedIndex < 0) {
          photos[photos.length - 1].modal.open();
          return;
        }
        if (selectedIndex >= photos.length) {
          photos[0].modal.open();
          return;
        }
        photos[selectedIndex].modal.open();
      });

      p.addEventListener('click', (e) => {
        e.preventDefault();
        p.modal.open();
      });
    });
  });
};

export default initGallery;
